import script from "./MultiSelectPicker.vue?vue&type=script&lang=ts&setup=true"
export * from "./MultiSelectPicker.vue?vue&type=script&lang=ts&setup=true"

import "./MultiSelectPicker.vue?vue&type=style&index=0&id=36c09fb7&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36c09fb7"]])

export default __exports__